var e=Object.defineProperty;var r=function(r,a){return e(r,"name",{value:a,configurable:!0})};export{r as a};